module.exports = {"140521100":"龙港镇","140521101":"中村镇","140521102":"郑庄镇","140521103":"端氏镇","140521104":"嘉峰镇","140521105":"郑村镇","140521106":"柿庄镇","140521200":"樊村河乡","140521201":"土沃乡","140521202":"张村乡","140521203":"苏庄乡","140521204":"胡底乡","140521205":"固县乡","140521206":"十里乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140521.json
// module id = 270
// module chunks = 0